import {
  JOB_BOARD_SHOW_PAYMENT_POPUP,
  PAYMENT_POPUP_SET_ACH_INFO,
  PAYMENT_POPUP_SET_BILLING_INFO,
  PAYMENT_POPUP_SET_CARD_INFO, PAYMENT_POPUP_SET_JOB_TRANSACTIONS,
  PAYMENT_POPUP_SET_PAYMENT_AMOUNT,
  PAYMENT_POPUP_SET_PAYMENT_ERRORS, PAYMENT_POPUP_SET_PAYMENT_STATUS,
  PAYMENT_POPUP_SET_PAYMENT_STEP,
  PAYMENT_POPUP_SET_PAYMENT_TYPE,
  PAYMENT_POPUP_SET_REFUND_TRANSACTION,
  PAYMENT_POPUP_SET_REFUND_TRANSACTION_ID,
  PAYMENT_POPUP_SET_REFUND_TRANSACTION_STATUS,
  PAYMENT_POPUP_SET_USE_CUSTOM_AMOUNT
} from "../../../constants/actionTypes";

export const PAYMENT_TYPES = {
  ACH: "ACH",
  card: "card",
  // bitcoin: "bitcoin",
  // payPal: "payPal",
}

export const PAYMENT_STEPS = {
  billing: 0,
  payments: 1,
  adjustPrice: 2,
  finalPage: 3,
  transactions: 4,
}

export const TRANSACTION_STATUSES = {
  Pending: "Pending",
  Failed: "Failed",
  Error: "Error",
  Success: "Success", // custom
  Refunded: "Refunded", // custom
}

const initialState = {
  billingInfo: {
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    country: "",
    postal: "",
    email: "",
  },
  paymentType: PAYMENT_TYPES.ACH,
  paymentStep: 0,
  jobTotal: 0,
  jobId: 0,
  useCustomAmount: false,
  percentageAmount: 100,
  customAmount: 0,
  paymentTotal: 0,
  achInfo: {
    accountNumber: "",
    routingNumber: "",
  },
  cardInfo: {
    cardNumber: "",
    cardExpiryMonth: "",
    cardExpiryYear: "",
    cardCvv: "",
  },
  paymentErrors: {}, // {"fullName": ["too short"]}, {"phoneNumber": ["this field is required"]}, etc.
  paymentStatus: null, // {status: "Error", transactionId: 5,} //
  refundTransactionId: "",
  refundTransactionStatus: "",
  // transactionsList: [
  //   {
  //     id: "2443083da-462e-42cf-902f",
  //     created: 1713190066,
  //     amount: 20,
  //     status: "Error",
  //     paymentType: PAYMENT_TYPES.card,
  //   },
  //   {
  //     id: "245083da-220e-42cf-902f",
  //     created: 1713190066,
  //     amount: 100,
  //     status: "Pending",
  //     paymentType: PAYMENT_TYPES.card,
  //   },
  //   {
  //     id: "19f315c9-ebc9-475a-bd91",
  //     created: 1716214066,
  //     amount: 50,
  //     status: "Success",
  //     paymentType: PAYMENT_TYPES.card,
  //   },
  //   {
  //     id: "8842657e-496a-4360-8139",
  //     created: 1725001666,
  //     amount: 20,
  //     status: "Refunded",
  //     paymentType: PAYMENT_TYPES.ACH,
  //   },
  // ],
  transactionsList: [],
};

export default function jobPaymentState(state = initialState, action) {
  switch(action.type) {
    case JOB_BOARD_SHOW_PAYMENT_POPUP:
      if (action.payload.showJobPaymentPopup) {
        return {
          ...state,
          jobTotal: action.payload.job ? action.payload.job.total : 0,
          jobId: action.payload.job ? action.payload.job.id : 0,
          paymentTotal : action.payload.job ? action.payload.job.total : 0,
          customAmount : action.payload.job ? action.payload.job.total : 0,
        }
      }
      return {...state,
        jobTotal: 0,
        paymentTotal: 0,
        paymentStep: 0,
        percentageAmount: 100,
        customAmount: 0,
        useCustomAmount: false
      };
    case PAYMENT_POPUP_SET_BILLING_INFO:
      return {...state, billingInfo: {...state.billingInfo, ...action.payload}};
    case PAYMENT_POPUP_SET_PAYMENT_TYPE:
    case PAYMENT_POPUP_SET_PAYMENT_STEP:
    case PAYMENT_POPUP_SET_USE_CUSTOM_AMOUNT:
    case PAYMENT_POPUP_SET_PAYMENT_AMOUNT:
    case PAYMENT_POPUP_SET_REFUND_TRANSACTION_ID:
    case PAYMENT_POPUP_SET_REFUND_TRANSACTION_STATUS:
    case PAYMENT_POPUP_SET_PAYMENT_STATUS:
    case PAYMENT_POPUP_SET_JOB_TRANSACTIONS:
      return {...state, ...action.payload};
    case PAYMENT_POPUP_SET_ACH_INFO:
      return {...state, achInfo: {...state.achInfo, ...action.payload}};
    case PAYMENT_POPUP_SET_CARD_INFO:
      return {...state, cardInfo: {...state.cardInfo, ...action.payload}};
    case PAYMENT_POPUP_SET_PAYMENT_ERRORS:
      return {...state, paymentErrors: {...state.paymentErrors, ...action.payload}};
    default:
      return state;
  }
}
